import React from 'react';
import { Link } from 'react-router-dom';

import Icon from '../components/common/Icon';
import DesktopDownload from '../components/download/DesktopDownload';
import { RELEASES_PAGE } from '../hooks/useDesktopRelease';

/**
 * Public download page for the desktop app.
 *
 * Public on purpose: the marketing site links straight here, and a
 * logged-out visitor has to be able to get the installer. Signed-in
 * users reach the same choices through the header instead, without
 * leaving the app - see DesktopDownloadModal.
 *
 * Everything below the hero is `DesktopDownload`, shared with that
 * modal. This file owns only the framing a standalone page needs and
 * the modal does not: a way back to the product, and the three
 * sentences explaining what the app is to someone who has never seen
 * it.
 */
const HIGHLIGHTS = [
  {
    icon: 'mic',
    title: 'Native audio capture',
    body: 'Hears the meeting and your microphone directly, with no browser tab to keep in focus.',
  },
  {
    icon: 'sparkles',
    title: 'A floating assistant panel',
    body: 'Keep suggested answers beside your meeting. On Ubuntu, the panel can appear in recordings and screen shares.',
  },
  {
    icon: 'refresh',
    title: 'Updates itself',
    body: 'New versions install on launch. Your account and history are the same as on the web.',
  },
];

export default function DownloadPage() {
  return (
    <div className="download-page">
      <div className="download-shell">
        <header className="download-topbar">
          <Link to="/" className="download-brand">
            <Icon name="waveform" size={22} />
            <span>KrishvaQ</span>
          </Link>
          <Link to="/login" className="download-topbar-link">
            Use KrishvaQ on the web
          </Link>
        </header>

        <div className="download-grid">
          <main className="download-main">
            <h1>KrishvaQ for desktop</h1>
            <p className="download-lede">
              Native audio capture, a floating assistant panel beside your
              meeting, and the same account you use on the web.
            </p>

            <DesktopDownload />
          </main>

          <aside className="download-aside">
            <ul className="download-highlights">
              {HIGHLIGHTS.map((item) => (
                <li key={item.title}>
                  <span className="download-highlight-icon">
                    <Icon name={item.icon} size={18} />
                  </span>
                  <span>
                    <strong>{item.title}</strong>
                    <span>{item.body}</span>
                  </span>
                </li>
              ))}
            </ul>

            <p className="download-managed">
              Managed deployment? An MSI is available on the{' '}
              <a href={RELEASES_PAGE} rel="noreferrer">
                releases page
              </a>
              .
            </p>
          </aside>
        </div>
      </div>
    </div>
  );
}
